import { requireDashboardOrigin } from "@playbrain/auth/server/dashboardOriginGuard"
import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/dashboard/auth/logout")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          const { logoutDashboardResponse } = await import("@api/features/dashboard-auth/dashboardAuthApi")
          return logoutDashboardResponse(request)
        },
      },
    },
  })
)
